import React from 'react'

import { ErrorPage as BaseErrorPage } from 'pharmacy/src/pages/error'

import useHomePath from '../../hooks/useHomePath'

const ErrorPage = (props) => {
  const { homePath } = useHomePath()

  return (
    <BaseErrorPage
      homepageProps={() => ({
        pathname: homePath,
        external: true,
      })}
      backProps={(history) => ({
        onClick: history.goBack,
      })}
      {...props}
    />
  )
}

export default ErrorPage
